import React from 'react';
// import data
import { features } from '../data';

const Feature3 = () => {
  // destructure features
  const { feature3 } = features;
  // destructure feature3
  const { pretitle, title, subtitle, image } = feature3;
  return (
    <section className='section border-2'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row lg:items-center lg:gap-x-[30px]'>
          {/* text */}
          <div className='flex-1' data-aos='fade-right' data-aos-offset='200'>
            <div className='pretitle'>{pretitle}</div>
            <h2 className='title'>{title}</h2>
            <p className='lead'>{subtitle}</p>
          </div>
          {/* image */}
          <div className='flex-1 rounded-lg' data-aos='fade-left' data-aos-offset='200'>
            <img className="w-full rounded-lg md:rounded-lg" src={image} alt='' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feature3;
